import { Ban } from 'lucide-react';
import { Customer } from '@/types/customer-type';

/** Red banner shown on customer panels when the customer is blocked. */
export default function BlockedCustomerBanner({ customer }: { customer: Customer }) {
  if (!customer.blocked) return null;
  return (
    <div className="flex items-start gap-2 rounded-lg border border-red-300 bg-red-50 p-2 text-red-700">
      <Ban className="mt-0.5 h-4 w-4 shrink-0" />
      <div className="min-w-0 text-xs">
        <p className="font-bold uppercase">Blocked customer</p>
        {customer.blockReason && <p className="break-words">Reason: {customer.blockReason}</p>}
        {(customer.blockedByName || customer.blockedAt) && (
          <p className="text-red-500">
            {customer.blockedByName ? `By ${customer.blockedByName}` : ''}
            {customer.blockedAt ? ` · ${new Date(customer.blockedAt).toLocaleString()}` : ''}
          </p>
        )}
      </div>
    </div>
  );
}
